let view = null;

export default {
	namespace: 'single-project',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: SingleProjectView } = await import(
			/* webpackChunkName: "single-project-view" */ '../../templates/SingleProjectView'
		);
		view = new SingleProjectView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
